export type FileInfo = {
  name: string;
  url: string;
  type: string;
};

export const createFileInfo = (file: File): FileInfo => {
  return {
    name: file.name,
    url: URL.createObjectURL(file),
    type: file.type,
  };
};

export const loadFileAsync = async (fileInfo: FileInfo): Promise<File> => {
  const result = await fetch(fileInfo.url);
  const blob = await result.blob();
  const file = new File([blob], fileInfo.name, { type: fileInfo.type });
  return file;
};
